import { Address, Contact, Link, ProductGroup, Profession, Topic, Video } from '@planone/bau365/util-fair-data';

export const linkMock: Link = {
  text: 'Link Text',
  path: 'https://plan.one',
};

export const productGroupMock: ProductGroup = {
  id: '100.100',
  external_id: '100.100',
  name: 'Produktlinie',
  root_path: ['100'],
};

export const topicMock: Topic = {
  id: '100.100',
  name: 'Material',
  description: 'Tolles Material',
};

export const professionMock: Profession = {
  id: '100.100',
  name: 'Innenausbau',
  topics: [topicMock],
};

export const contactMock: Contact = {
  phone: '01234567890',
  email: 'email@myexhibitor.com',
  fax: '09876543210',
};

export const addressMock: Address = {
  street: 'ABC Street',
  house_number: '123',
  zip_code: '98765',
  city: 'Bielefeld',
  country: 'Germany',
};

export function imageMock() {
  return {
    resource:
      'https://picsum.photos/' + generateRandomIntegerInRange(200, 500) + '/' + generateRandomIntegerInRange(200, 500),
    provider: 'RAW',
  };
}

export function describedImageMock() {
  return {
    description: 'Test',
    resource:
      'https://picsum.photos/' + generateRandomIntegerInRange(200, 500) + '/' + generateRandomIntegerInRange(200, 500),
    provider: 'RAW',
  };
}

export const videoMock: Video = {
  provider: 'YOUTUBE',
  resource: '7X8II6J-6mU',
};

function generateRandomIntegerInRange(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
